import React, { CSSProperties } from 'react';
import { observer } from 'mobx-react';

interface PhotoProps {
  src: string;
  isDisabled?: boolean;

  onClick?: () => any;
}

const Photo: React.FC<PhotoProps> = observer(({ onClick, src, isDisabled }) => {
  const wrapperClassName = isDisabled ? 'nes-btn is-disabled' : 'nes-btn';
  return (
    <div style={wrapperStyle} className={wrapperClassName} onClick={onClick}>
      <img style={imgStyle} src={src} alt={''} key={src} />
    </div>
  );
});

const imgStyle: CSSProperties = { objectFit: 'contain', width: '100%', maxHeight: '100%' };

const wrapperStyle: CSSProperties = {
  opacity: 1,
  boxShadow: 'none',
  backgroundColor: 'white',
  width: '47%',
  display: 'flex',
  alignItems: 'center',
};

export { Photo };
